<script lang="ts" setup>
import LoadingSpinner from '@/components/common/LoadingSpinner.vue';
</script>
<template>
    <div class="ag-overlay-loading-center">
        <LoadingSpinner
            style="width: 100%; height: 100%"
            size="xxlarge"
        />
    </div>
</template>
